import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  minWidth: '256px',
  backgroundColor: theme.palette.background.default,
  height: '100%',
  left: '64px',
  border: '1px solid rgba(0, 0, 0, 0.1)',
  zIndex: 1,
}));
